import { getSwishAppRedirectUrl } from '~/components/payment/deposit/utils/swish-app-redirect-util';
import { limitsConst, FETCH_TYPE_SYNCH, FETCH_TYPE_ASYNCH } from '~/components/payment/common/lib/utils/constants';
import {
	applePaySupportedMethodCodes,
	isApplePaySupported,
	createPaymentRequest,
	setUpApplePaySession
} from '~/components/payment/util/apple-pay';
import usePaypalOrderRef from '~/components/payment/hooks/use-paypal-order-ref';
import encryptStringWithRsaPublicKey from '~/components/payment/util/encrypt-util';
import { creditCard, neteller } from '~/components/payment/deposit/data/validate';
import formRedirect, { transformAndPost } from '~/components/payment/deposit/components/form-redirect';
import {
	fetchfingerPrintData as getFingerPrintData,
	sendThreeDSData
} from '~/components/payment/deposit/components/get-finger-print-data';

const constants = { FETCH_TYPE_SYNCH, FETCH_TYPE_ASYNCH };

export {
	neteller,
	constants,
	creditCard,
	limitsConst,
	formRedirect,
	sendThreeDSData,
	transformAndPost,
	usePaypalOrderRef,
	getFingerPrintData,
	isApplePaySupported,
	createPaymentRequest,
	setUpApplePaySession,
	getSwishAppRedirectUrl,
	applePaySupportedMethodCodes,
	encryptStringWithRsaPublicKey
};
